import { fetchCMSData } from "@clients/contentfulClient";
import { mappedUrlStructure } from "@utils/mappers/urlStructureMapper";
import { SiteCacheItem, siteCacheFetch } from "@utils/siteStructureCache";

import { GET_URL_STRUCTURE_M } from "queries/pages/getUrlStructure";
import { UrlStructure } from "types/UrlStructure";
import { UrlStructureItem } from "types/UrlStructureItem";

import { getFactsUrlStructure } from "./FactsUrlStructureService";
import { getFaqUrlStructure } from "./FaqStructureService";
import { getPressreleaseUrlStructure } from "./PressReleaseUrlStructure";

export const UrlStructureService = async (preview: boolean): Promise<UrlStructure> => {
  if (preview) {
    return fetchUrlStructure(preview);
  }
  return siteCacheFetch(SiteCacheItem.URL_STRUCTURE, () => fetchUrlStructure(preview));
};

const fetchUrlStructure = async (preview: boolean): Promise<UrlStructure> => {
  const [siteStructureUrls, factsUrls, faqUrls, pressreleaseUrls] = await Promise.all([
    getUrlStructureItems(preview),
    getFactsUrlStructure(preview),
    getFaqUrlStructure(preview),
    getPressreleaseUrlStructure(),
  ]);

  const urls = [].concat(siteStructureUrls, factsUrls, faqUrls, pressreleaseUrls);
  return { urls };
};

export const getUrlStructureItems = async (preview: boolean): Promise<UrlStructureItem[]> => {
  if (preview) {
    return fetchUrlStructureItems(preview);
  }
  return siteCacheFetch(SiteCacheItem.URL_STRUCTURE_ITEMS, () => fetchUrlStructureItems(preview));
};

const fetchUrlStructureItems = async (preview: boolean): Promise<UrlStructureItem[]> => {
  const pages: any = [];
  const startPageId = "2tQazCSl7vss6GcHOK4i36";

  const getAllPages = async (limit, skip) => {
    const { data: siteStructure } = await fetchCMSData(
      GET_URL_STRUCTURE_M(limit, skip, preview),
      preview,
    );
    for (const i of siteStructure?.pageCollection?.items) {
      pages.push(i);
    }
    if (siteStructure?.pageCollection?.total > pages.length) {
      return await getAllPages(limit, pages.length);
    }
    return pages;
  };

  const allPages = await getAllPages(200, 0);
  return mappedUrlStructure(allPages, startPageId);
};
